import { Controller, type Control } from 'react-hook-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface CheckboxInputProps {
  label: string;
  name: string;
  control: Control<any>;
  required?: boolean;
  defaultValue?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
}

export default function CheckboxInput({
  label,
  name,
  control,
  required = false,
  defaultValue = false,
  disabled = false,
  disabledMessage,
}: CheckboxInputProps) {
  const fullLabel = disabledMessage ? `${label} (${disabledMessage})` : label;
  return (
    <FormControlLabel
      label={fullLabel}
      control={
        <Controller
          name={name as any}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Checkbox
              color="primary"
              required={required}
              disabled={disabled}
              onChange={(e) =>
                field.onChange(e.target.checked && !disabledMessage)
              }
              checked={field.value}
            />
          )}
        />
      }
    />
  );
}
